// countryCodes.js — Mapa completo país → código telefónico (dial) + ISO.
// Se usa para que el selector de código telefónico cubra todos los países
// disponibles (antes estaba hardcodeado con solo ~10).
// Nombres en español (como se listan en el selector de países del admin).

export const PAISES_CODIGOS = [
  { nombre: 'Afganistán', iso: 'AF', dial: '+93' },
  { nombre: 'Albania', iso: 'AL', dial: '+355' },
  { nombre: 'Alemania', iso: 'DE', dial: '+49' },
  { nombre: 'Andorra', iso: 'AD', dial: '+376' },
  { nombre: 'Angola', iso: 'AO', dial: '+244' },
  { nombre: 'Anguila', iso: 'AI', dial: '+1' },
  { nombre: 'Antigua y Barbuda', iso: 'AG', dial: '+1' },
  { nombre: 'Arabia Saudita', iso: 'SA', dial: '+966' },
  { nombre: 'Argelia', iso: 'DZ', dial: '+213' },
  { nombre: 'Argentina', iso: 'AR', dial: '+54' },
  { nombre: 'Armenia', iso: 'AM', dial: '+374' },
  { nombre: 'Aruba', iso: 'AW', dial: '+297' },
  { nombre: 'Australia', iso: 'AU', dial: '+61' },
  { nombre: 'Austria', iso: 'AT', dial: '+43' },
  { nombre: 'Azerbaiyán', iso: 'AZ', dial: '+994' },
  { nombre: 'Bahamas', iso: 'BS', dial: '+1' },
  { nombre: 'Baréin', iso: 'BH', dial: '+973' },
  { nombre: 'Bangladés', iso: 'BD', dial: '+880' },
  { nombre: 'Barbados', iso: 'BB', dial: '+1' },
  { nombre: 'Bélgica', iso: 'BE', dial: '+32' },
  { nombre: 'Belice', iso: 'BZ', dial: '+501' },
  { nombre: 'Benín', iso: 'BJ', dial: '+229' },
  { nombre: 'Bielorrusia', iso: 'BY', dial: '+375' },
  { nombre: 'Birmania', iso: 'MM', dial: '+95' },
  { nombre: 'Bolivia', iso: 'BO', dial: '+591' },
  { nombre: 'Bosnia y Herzegovina', iso: 'BA', dial: '+387' },
  { nombre: 'Botsuana', iso: 'BW', dial: '+267' },
  { nombre: 'Brasil', iso: 'BR', dial: '+55' },
  { nombre: 'Brunéi', iso: 'BN', dial: '+673' },
  { nombre: 'Bulgaria', iso: 'BG', dial: '+359' },
  { nombre: 'Burkina Faso', iso: 'BF', dial: '+226' },
  { nombre: 'Burundi', iso: 'BI', dial: '+257' },
  { nombre: 'Bután', iso: 'BT', dial: '+975' },
  { nombre: 'Cabo Verde', iso: 'CV', dial: '+238' },
  { nombre: 'Camboya', iso: 'KH', dial: '+855' },
  { nombre: 'Camerún', iso: 'CM', dial: '+237' },
  { nombre: 'Canadá', iso: 'CA', dial: '+1' },
  { nombre: 'Catar', iso: 'QA', dial: '+974' },
  { nombre: 'Chad', iso: 'TD', dial: '+235' },
  { nombre: 'Chile', iso: 'CL', dial: '+56' },
  { nombre: 'China', iso: 'CN', dial: '+86' },
  { nombre: 'Chipre', iso: 'CY', dial: '+357' },
  { nombre: 'Colombia', iso: 'CO', dial: '+57' },
  { nombre: 'Comoras', iso: 'KM', dial: '+269' },
  { nombre: 'Congo', iso: 'CG', dial: '+242' },
  { nombre: 'Corea del Norte', iso: 'KP', dial: '+850' },
  { nombre: 'Corea del Sur', iso: 'KR', dial: '+82' },
  { nombre: 'Costa de Marfil', iso: 'CI', dial: '+225' },
  { nombre: 'Costa Rica', iso: 'CR', dial: '+506' },
  { nombre: 'Croacia', iso: 'HR', dial: '+385' },
  { nombre: 'Cuba', iso: 'CU', dial: '+53' },
  { nombre: 'Curazao', iso: 'CW', dial: '+599' },
  { nombre: 'Dinamarca', iso: 'DK', dial: '+45' },
  { nombre: 'Dominica', iso: 'DM', dial: '+1' },
  { nombre: 'Ecuador', iso: 'EC', dial: '+593' },
  { nombre: 'Egipto', iso: 'EG', dial: '+20' },
  { nombre: 'El Salvador', iso: 'SV', dial: '+503' },
  { nombre: 'Emiratos Árabes Unidos', iso: 'AE', dial: '+971' },
  { nombre: 'Eritrea', iso: 'ER', dial: '+291' },
  { nombre: 'Eslovaquia', iso: 'SK', dial: '+421' },
  { nombre: 'Eslovenia', iso: 'SI', dial: '+386' },
  { nombre: 'España', iso: 'ES', dial: '+34' },
  { nombre: 'Estados Unidos', iso: 'US', dial: '+1' },
  { nombre: 'Estonia', iso: 'EE', dial: '+372' },
  { nombre: 'Etiopía', iso: 'ET', dial: '+251' },
  { nombre: 'Filipinas', iso: 'PH', dial: '+63' },
  { nombre: 'Finlandia', iso: 'FI', dial: '+358' },
  { nombre: 'Fiyi', iso: 'FJ', dial: '+679' },
  { nombre: 'Francia', iso: 'FR', dial: '+33' },
  { nombre: 'Gabón', iso: 'GA', dial: '+241' },
  { nombre: 'Gambia', iso: 'GM', dial: '+220' },
  { nombre: 'Georgia', iso: 'GE', dial: '+995' },
  { nombre: 'Ghana', iso: 'GH', dial: '+233' },
  { nombre: 'Gibraltar', iso: 'GI', dial: '+350' },
  { nombre: 'Granada', iso: 'GD', dial: '+1' },
  { nombre: 'Grecia', iso: 'GR', dial: '+30' },
  { nombre: 'Groenlandia', iso: 'GL', dial: '+299' },
  { nombre: 'Guadalupe', iso: 'GP', dial: '+590' },
  { nombre: 'Guam', iso: 'GU', dial: '+1' },
  { nombre: 'Guatemala', iso: 'GT', dial: '+502' },
  { nombre: 'Guayana Francesa', iso: 'GF', dial: '+594' },
  { nombre: 'Guinea', iso: 'GN', dial: '+224' },
  { nombre: 'Guinea Ecuatorial', iso: 'GQ', dial: '+240' },
  { nombre: 'Guinea-Bisáu', iso: 'GW', dial: '+245' },
  { nombre: 'Guyana', iso: 'GY', dial: '+592' },
  { nombre: 'Haití', iso: 'HT', dial: '+509' },
  { nombre: 'Honduras', iso: 'HN', dial: '+504' },
  { nombre: 'Hong Kong', iso: 'HK', dial: '+852' },
  { nombre: 'Hungría', iso: 'HU', dial: '+36' },
  { nombre: 'India', iso: 'IN', dial: '+91' },
  { nombre: 'Indonesia', iso: 'ID', dial: '+62' },
  { nombre: 'Irak', iso: 'IQ', dial: '+964' },
  { nombre: 'Irán', iso: 'IR', dial: '+98' },
  { nombre: 'Irlanda', iso: 'IE', dial: '+353' },
  { nombre: 'Islandia', iso: 'IS', dial: '+354' },
  { nombre: 'Islas Caimán', iso: 'KY', dial: '+1' },
  { nombre: 'Israel', iso: 'IL', dial: '+972' },
  { nombre: 'Italia', iso: 'IT', dial: '+39' },
  { nombre: 'Jamaica', iso: 'JM', dial: '+1' },
  { nombre: 'Japón', iso: 'JP', dial: '+81' },
  { nombre: 'Jordania', iso: 'JO', dial: '+962' },
  { nombre: 'Kazajistán', iso: 'KZ', dial: '+7' },
  { nombre: 'Kenia', iso: 'KE', dial: '+254' },
  { nombre: 'Kirguistán', iso: 'KG', dial: '+996' },
  { nombre: 'Kuwait', iso: 'KW', dial: '+965' },
  { nombre: 'Laos', iso: 'LA', dial: '+856' },
  { nombre: 'Lesoto', iso: 'LS', dial: '+266' },
  { nombre: 'Letonia', iso: 'LV', dial: '+371' },
  { nombre: 'Líbano', iso: 'LB', dial: '+961' },
  { nombre: 'Liberia', iso: 'LR', dial: '+231' },
  { nombre: 'Libia', iso: 'LY', dial: '+218' },
  { nombre: 'Liechtenstein', iso: 'LI', dial: '+423' },
  { nombre: 'Lituania', iso: 'LT', dial: '+370' },
  { nombre: 'Luxemburgo', iso: 'LU', dial: '+352' },
  { nombre: 'Macao', iso: 'MO', dial: '+853' },
  { nombre: 'Macedonia del Norte', iso: 'MK', dial: '+389' },
  { nombre: 'Madagascar', iso: 'MG', dial: '+261' },
  { nombre: 'Malasia', iso: 'MY', dial: '+60' },
  { nombre: 'Malaui', iso: 'MW', dial: '+265' },
  { nombre: 'Maldivas', iso: 'MV', dial: '+960' },
  { nombre: 'Malí', iso: 'ML', dial: '+223' },
  { nombre: 'Malta', iso: 'MT', dial: '+356' },
  { nombre: 'Marruecos', iso: 'MA', dial: '+212' },
  { nombre: 'Martinica', iso: 'MQ', dial: '+596' },
  { nombre: 'Mauricio', iso: 'MU', dial: '+230' },
  { nombre: 'Mauritania', iso: 'MR', dial: '+222' },
  { nombre: 'México', iso: 'MX', dial: '+52' },
  { nombre: 'Moldavia', iso: 'MD', dial: '+373' },
  { nombre: 'Mónaco', iso: 'MC', dial: '+377' },
  { nombre: 'Mongolia', iso: 'MN', dial: '+976' },
  { nombre: 'Montenegro', iso: 'ME', dial: '+382' },
  { nombre: 'Mozambique', iso: 'MZ', dial: '+258' },
  { nombre: 'Namibia', iso: 'NA', dial: '+264' },
  { nombre: 'Nepal', iso: 'NP', dial: '+977' },
  { nombre: 'Nicaragua', iso: 'NI', dial: '+505' },
  { nombre: 'Níger', iso: 'NE', dial: '+227' },
  { nombre: 'Nigeria', iso: 'NG', dial: '+234' },
  { nombre: 'Noruega', iso: 'NO', dial: '+47' },
  { nombre: 'Nueva Zelanda', iso: 'NZ', dial: '+64' },
  { nombre: 'Omán', iso: 'OM', dial: '+968' },
  { nombre: 'Países Bajos', iso: 'NL', dial: '+31' },
  { nombre: 'Pakistán', iso: 'PK', dial: '+92' },
  { nombre: 'Palaos', iso: 'PW', dial: '+680' },
  { nombre: 'Palestina', iso: 'PS', dial: '+970' },
  { nombre: 'Panamá', iso: 'PA', dial: '+507' },
  { nombre: 'Papúa Nueva Guinea', iso: 'PG', dial: '+675' },
  { nombre: 'Paraguay', iso: 'PY', dial: '+595' },
  { nombre: 'Perú', iso: 'PE', dial: '+51' },
  { nombre: 'Polinesia Francesa', iso: 'PF', dial: '+689' },
  { nombre: 'Polonia', iso: 'PL', dial: '+48' },
  { nombre: 'Portugal', iso: 'PT', dial: '+351' },
  { nombre: 'Puerto Rico', iso: 'PR', dial: '+1' },
  { nombre: 'Reino Unido', iso: 'GB', dial: '+44' },
  { nombre: 'República Centroafricana', iso: 'CF', dial: '+236' },
  { nombre: 'República Checa', iso: 'CZ', dial: '+420' },
  { nombre: 'República del Congo', iso: 'CG', dial: '+242' },
  { nombre: 'República Democrática del Congo', iso: 'CD', dial: '+243' },
  { nombre: 'República Dominicana', iso: 'DO', dial: '+1' },
  { nombre: 'Ruanda', iso: 'RW', dial: '+250' },
  { nombre: 'Rumania', iso: 'RO', dial: '+40' },
  { nombre: 'Rusia', iso: 'RU', dial: '+7' },
  { nombre: 'Sáhara Occidental', iso: 'EH', dial: '+212' },
  { nombre: 'Samoa', iso: 'WS', dial: '+685' },
  { nombre: 'San Cristóbal y Nieves', iso: 'KN', dial: '+1' },
  { nombre: 'San Marino', iso: 'SM', dial: '+378' },
  { nombre: 'San Vicente y las Granadinas', iso: 'VC', dial: '+1' },
  { nombre: 'Santa Lucía', iso: 'LC', dial: '+1' },
  { nombre: 'Santo Tomé y Príncipe', iso: 'ST', dial: '+239' },
  { nombre: 'Senegal', iso: 'SN', dial: '+221' },
  { nombre: 'Serbia', iso: 'RS', dial: '+381' },
  { nombre: 'Seychelles', iso: 'SC', dial: '+248' },
  { nombre: 'Sierra Leona', iso: 'SL', dial: '+232' },
  { nombre: 'Singapur', iso: 'SG', dial: '+65' },
  { nombre: 'Siria', iso: 'SY', dial: '+963' },
  { nombre: 'Somalia', iso: 'SO', dial: '+252' },
  { nombre: 'Sri Lanka', iso: 'LK', dial: '+94' },
  { nombre: 'Suazilandia', iso: 'SZ', dial: '+268' },
  { nombre: 'Sudáfrica', iso: 'ZA', dial: '+27' },
  { nombre: 'Sudán', iso: 'SD', dial: '+249' },
  { nombre: 'Sudán del Sur', iso: 'SS', dial: '+211' },
  { nombre: 'Suecia', iso: 'SE', dial: '+46' },
  { nombre: 'Suiza', iso: 'CH', dial: '+41' },
  { nombre: 'Surinam', iso: 'SR', dial: '+597' },
  { nombre: 'Tailandia', iso: 'TH', dial: '+66' },
  { nombre: 'Taiwán', iso: 'TW', dial: '+886' },
  { nombre: 'Tanzania', iso: 'TZ', dial: '+255' },
  { nombre: 'Tayikistán', iso: 'TJ', dial: '+992' },
  { nombre: 'Timor Oriental', iso: 'TL', dial: '+670' },
  { nombre: 'Togo', iso: 'TG', dial: '+228' },
  { nombre: 'Tonga', iso: 'TO', dial: '+676' },
  { nombre: 'Trinidad y Tobago', iso: 'TT', dial: '+1' },
  { nombre: 'Túnez', iso: 'TN', dial: '+216' },
  { nombre: 'Turkmenistán', iso: 'TM', dial: '+993' },
  { nombre: 'Turquía', iso: 'TR', dial: '+90' },
  { nombre: 'Ucrania', iso: 'UA', dial: '+380' },
  { nombre: 'Uganda', iso: 'UG', dial: '+256' },
  { nombre: 'Uruguay', iso: 'UY', dial: '+598' },
  { nombre: 'Uzbekistán', iso: 'UZ', dial: '+998' },
  { nombre: 'Vanuatu', iso: 'VU', dial: '+678' },
  { nombre: 'Venezuela', iso: 'VE', dial: '+58' },
  { nombre: 'Vietnam', iso: 'VN', dial: '+84' },
  { nombre: 'Yemen', iso: 'YE', dial: '+967' },
  { nombre: 'Yibuti', iso: 'DJ', dial: '+253' },
  { nombre: 'Zambia', iso: 'ZM', dial: '+260' },
  { nombre: 'Zimbabue', iso: 'ZW', dial: '+263' },
];

// Normaliza para comparar nombres sin acentos / mayúsculas / espacios.
const norm = (s) => (s || '')
  .toString().toLowerCase().trim()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Alias frecuentes (otras formas de escribir el mismo país).
const ALIAS = {
  'mexico': 'México', 'usa': 'Estados Unidos', 'eeuu': 'Estados Unidos',
  'estados unidos de america': 'Estados Unidos', 'united states': 'Estados Unidos',
  'reino unido de gran bretana': 'Reino Unido', 'inglaterra': 'Reino Unido',
  'corea': 'Corea del Sur', 'republica dominicana': 'República Dominicana',
  'rep dominicana': 'República Dominicana',
};

const LOOKUP = (() => {
  const m = {};
  PAISES_CODIGOS.forEach(p => { m[norm(p.nombre)] = p; });
  Object.entries(ALIAS).forEach(([a, name]) => {
    const target = PAISES_CODIGOS.find(p => p.nombre === name);
    if (target) m[norm(a)] = target;
  });
  return m;
})();

// Devuelve {nombre, iso, dial} para un nombre de país (o null si no se encuentra).
export function buscarCodigoPais(nombrePais) {
  if (!nombrePais) return null;
  return LOOKUP[norm(nombrePais)] || null;
}

// Lista completa de opciones de código (deduplicada por dial+iso), ordenada por nombre.
// Útil como fallback cuando el proyecto no definió una lista de países.
export const OPCIONES_CODIGO_COMPLETAS = PAISES_CODIGOS
  .slice()
  .sort((a, b) => a.nombre.localeCompare(b.nombre));
